"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var SearchButton = function () {
    var openSearch = (0, apps_shared_1.useOpenGameSearch)();
    return react_1.default.createElement("button", { className: styles_module_scss_1.default.button, onClick: openSearch });
};
exports.default = SearchButton;
